/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	ExportTargetMappingUpdatePathParams,
	ExportTargetMappingUpdateRequest,
	ExportTargetMappingUpdateResponse,
} from '../types/ExportTargetMappingUpdate'

/**
 * PATCH /export-target-mappings/:mapping
 * @see backend/nexus/modules/ExportIntegrations/Http/Controllers/ExportTargetMappingController.php ExportTargetMappingController::update
 */
export async function exportTargetMappingUpdate(
	mapping: ExportTargetMappingUpdatePathParams['mapping'],
	data: ExportTargetMappingUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<ExportTargetMappingUpdateResponse>> {
	return axiosInstance.patch(`/export-target-mappings/${mapping}`, data, config)
}
